import { dataHooks } from '@wix/data-hooks';

export const externalResourcesDataHooks = dataHooks<{
  wixLearn;
  wixBlog;
  seoLearningHub;
  veloHub;
  partnersForum;
  customerCareTickets;
  hireAnotherProfessional;
  communityForum;
  studioCommunityForum;
  wixDevelopers;
  wixDeveloperDocs;
  wixDeveloperCommunity;
  chatWithUs;
  tourTheEditor;
  newReleases;
}>('externalResources');
